import { FunctionComponent } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../../css/PublicWhatWeDoPage.css';

const Component07: FunctionComponent = () => {
  const navigate = useNavigate();
  const goToLoginPage = () => navigate('/public/login');

  return (
    <div className='public-what-we-do-page-component-seven-container vdr-wwd-doc'>
      <div className='vdr-section-head vdr-wwd-section-head'>
        <h2 className='public-what-we-do-page-title'>Estadísticas del sector</h2>
        <small>Indicadores</small>
      </div>
      <p className='public-what-we-do-page-text'>
        Estadísticas del sector proporciona acceso a datos clave sobre la distribución eléctrica,
        como la capacidad instalada y la capacidad de alojamiento. Estas estadísticas son
        fundamentales para identificar tendencias del sector, evaluar el desempeño de las redes y
        tomar decisiones estratégicas informadas sobre la gestión y expansión de la infraestructura
        eléctrica. Además, facilitan la elaboración de políticas y propuestas normativas que
        promueven la integración de recursos energéticos distribuidos, impulsando así la
        sostenibilidad a través del impulso de la transición energética.
      </p>
      <p className='public-what-we-do-page-text'>
        Las estadísticas de capacidad de alojamiento se alimentan con la información proporcionada
        por las empresas de distribución, la cual se almacena en la base de datos relacional
        detallada a través de la <b>herramienta de gestión de datos de redes</b>. Además, estas
        estadísticas se enriquecen con los estudios realizados por el equipo de investigación de
        <b> CENTRA </b>y con los resultados de los estudios públicos generados por los usuarios de
        nuestra plataforma web. Esto asegura el acceso a información actualizada, que proporciona
        una visión integral para la toma de decisiones y la planificación a largo plazo del sector
        eléctrico.
      </p>
      <div className='public-what-we-do-page-btn-container'>
        <button className='primary-button-style public-what-we-do-page-btn' onClick={goToLoginPage}>
          Explorar estadísticas
          <span aria-hidden='true'>→</span>
        </button>
      </div>
    </div>
  );
};

export default Component07;
